import { DororaidIcon } from '../../../shared/ui/DororaidIcon.jsx';
import './desktop-recent-results.css';
import { RaidPracticeDeckDisplay } from '../../raid-practice/shared/RaidPracticeDeckPicker.jsx';
import { formatRaidHpEok } from '../../../shared/domain/raidHpFormat.js';
import { selectRecentRaidResults } from './desktopChatMessages.js';

function timeLabel(value) {
  if (!value || !Number.isFinite(Date.parse(value))) return '';
  return new Intl.DateTimeFormat('ko-KR', { hour: '2-digit', minute: '2-digit' }).format(new Date(value));
}

export function DesktopRecentResults({ messages, collapsed = false, onToggle }) {
  const results = selectRecentRaidResults(messages);
  return <section className="raid-control-recent-results" aria-label="최근 실전 기록">
    <header><strong>최근 실전</strong>{onToggle ? <button type="button" onClick={onToggle} aria-expanded={!collapsed} aria-label={collapsed ? '최근 실전 펼치기' : '최근 실전 접기'}><DororaidIcon name={collapsed ? 'chevronUp' : 'chevronDown'} size={20} /></button> : null}</header>
    {!collapsed ? results.length ? <ol>{results.map((message) => {
      const event = message.eventData || {};
      return <li key={message.id}>
        <details>
          <summary>
            <span className="raid-control-recent-result-main"><strong>{event.memberNickname || message.authorNickname}</strong><b>{formatRaidHpEok(event.damageEok)}</b></span>
            <span className="raid-control-recent-result-meta"><span>{event.bossName || '보스'} · {event.phaseNo}단{event.isKill ? ' · 처치' : ''}</span><time>{timeLabel(event.attackedAt || message.createdAt)}</time></span>
            <span className="raid-control-recent-result-expand">상세 보기</span>
          </summary>
          {event.deck?.length ? <RaidPracticeDeckDisplay deck={event.deck} mobile={false} /> : <p>등록된 덱 정보 없음</p>}
        </details>
      </li>;
    })}</ol> : <p className="raid-control-recent-results-empty">반영된 실전 기록 없음</p> : null}
  </section>;
}
